import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Login from '@/components/Login'
import Entities from '@/components/Entities'
import Entity from '@/components/Entity'

Vue.use(Router)

let router = new Router({
	routes: [
		{
			path: "/",
			redirect: "/journey"
		},
		{
			path: "/login",
			name: "Login",
			component: Login
		},
		{
			path: "/journey",
			name: "Journey",
			component: Entities,
			meta: {
				requiresAuth: true,
				entityType: "journey"
			}
		},
		{
			path: "/location",
			name: "Location",
			component: Entities,
			meta: {
				requiresAuth: true,
				entityType: "location"
			}
		},
		{
			path: "/asset",
			name: "Asset",
			component: Entities,
			meta: {
				requiresAuth: true,
				entityType: "asset"
			}
		},
		{
			path: "/person",
			name: "Person",
			component: Entities,
			meta: {
				requiresAuth: true,
				entityType: "person"
			}
		},
		{
			path: '/:id([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})',
			name: "Entity",
			component: Entity
		}
	]
});

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// this route requires auth, check if logged in
		// if not, redirect to login page.
		if (!store.state.user.status.loggedIn) {
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			})
		} else {
			next()
		}
	} else {
		next() // make sure to always call next()!
	}
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js